<template>
  <article :id="$vnode.key" :class="value.updatedQuota && 'position-relative mb-4rem'">
    <custom-callout
      ref="callout"
      :has-toggle="true"
      :controlled="true"
      :opened="isOpen"
      class="mt-2 mb-3"
      @click:open="toggleCallout()"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-10 col-lg-11">
            <div class="row">
              <div class="col-6 col-md-3">
                <div class="info-text-title">Municipio:</div>
                <p class="info-text">
                  {{ value.municipality.name }}
                </p>
              </div>
              <div class="col-6 col-md-3">
                <div class="info-text-title">Escuela:</div>
                <p class="info-text">
                  {{ value.school.name }}
                </p>
              </div>
              <div class="col-6 col-md-3">
                <div class="info-text-title">
                  Nombre del Maestro:
                </div>
                <p class="info-text">
                  {{ (value.teacher && value.teacher.name) || "-" }}
                </p>
              </div>
              <div class="col-6 col-md-3">
                <div class="info-text-title">
                  Categoría de la Alternativa:
                </div>
                <p class="info-text">
                  {{ value.category.name }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-6 col-md-3">
                <div class="info-text-title">
                  Nombre de la Alternativa:
                </div>
                <p class="info-text">
                  {{ value.alternative?.name | empty }}
                </p>
              </div>
              <div class="col col-md">
                <div class="info-text-title">
                  Total de Estudiantes:
                </div>
                <p class="info-text">
                  {{ value?.numberOfStudents | empty }}
                </p>
              </div>
              <div class="col-6 col-md">
                <div class="info-text-title">
                  Especialidad de Salón:
                </div>
                <p class="info-text">
                  {{ value?.salonSpeciality?.name | empty }}
                </p>
              </div>
              <div class="col col-md">
                <div class="info-text-title">
                  Cupo:
                </div>
                <p class="info-text">
                  {{ value?.studentCapacity | empty }}
                </p>
              </div>
              <div class="col col-md">
                <div class="info-text-title">
                  Conteo Asistente:
                </div>
                <p class="info-text">
                  {{ formattedAssistantCount }}
                </p>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-md-2 col-lg-1 px-0 mt-2 mt-md-0 d-md-flex justify-content-start"
          >
            <div class="align-self-center">
              <ActionButton
                text="Entrar"
                variant="outline-success"
                :responsive="true"
                i="fas fa-file-import"
                @click="goManagement(value.id)"
              />
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div class="additional-container">
          <div class="p2 mt-1">
            <div class="bg-gray p-2">
              <div class="bg-white p-3 rounded pl-c-xl">
                <span class="mt-1">
                  <i class="fa fa-info-circle mr-2 color-primary-2" />
                  <span class="title color-gray-7 font-weight-bold">
                    Información Adicional
                  </span>
                </span>
                <StudentResultRow
                  v-for="item in collections.searchResult"
                  :key="item.studentSieId"
                  :value="item"
                />
                <div class="row pt-2">
                  <div class="col-12 pt-0">
                    <Pagination
                      v-if="pagination.totalItemCount > pagination.perPage"
                      :data="pagination"
                      :page-size="pagination.perPage"
                      :parent-id="$vnode.key"
                      @pagination-go-page="requestAdditionalInfo"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
        <div
      v-if="value.updatedQuota"
      class="rb-alert rounded-bottom pr-2 px-md-3 d-flex align-items-center position-absolute alert-pending"
    >
      <i
        class="fas fa-bell-exclamation font-24 mx-3 ml-lg-2"
      ></i>

      <p
        class="font-weight-normal my-auto font-14"
      >
        El cupo de estudiantes ha sido modificado debido a la siguiente razón [{{ value.updatedQuotaReason }}]
      </p>
    </div>
  </article>
</template>

<script>
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";
import Pagination from "pagination";
import StudentResultRow from "./StudentResultRow";
import { getAlternativeLocationTeacherStudents } from "@/modules/alternative-location-management/api";
export default {
  name: "SearchResultRowAdvanced",
  components: {
    CustomCallout,
    ActionButton,
    Pagination,
    StudentResultRow
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
      loaded: false,
      collections: {
        searchResult: []
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0
      }
    };
  },
  methods: {
    async toggleCallout() {
      this.isOpen = !this.isOpen;
      if (!this.isOpen || this.loaded) return;
      this.loaded = this.isOpen;
      await this.requestAdditionalInfo();
    },
    async requestAdditionalInfo(page = 1) {
      this.pagination.currentPage = page;
      const mappedFilter = {
        assignToId: this.value.teacher.id,
        schoolAlternativeLocationId: this.value.id,
        pageIndex: page,
        pageSize: this.pagination.perPage
      };

      await getAlternativeLocationTeacherStudents(mappedFilter).then(res => {
        this.collections.searchResult = res.data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count
        };
      });
    },
    goManagement(id) {
      this.$router.push(`/humanres/locationalternativemanagement/${id}`);
    }
  },
  computed: {
    formattedAssistantCount() {
      return (this.value?.numberOfAssistants || 0).toString().padStart(2, "0");
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.rb-alert {
  top: 97%;
  left: 0;
  width: 100%;
  padding: 10px 0;
}

.alert-pending {
  background-color: #FFF5E8;

  & p,
  i {
    color: #AF6708;
  }
}

.mb-4rem {
  margin-bottom: 4rem !important;
}

.info-text-title {
  color: map.get($colors, "gray-6");
  font-size: 1rem;
  font-weight: normal;
}

.info-text {
  color: map.get($colors, "black");
  font-weight: normal;
  font-size: 1rem;
  size: 1rem;
}
</style>
